import {DialogContent, styled} from "@mui/material";

export const WarningDialogContent = styled(DialogContent)(() => ({
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
}));
